





import {ERouteName} from '@customer-portal/shared';
import {Component, Vue} from 'vue-property-decorator';


@Component({
	components: {}
})
export default class Launch extends Vue {
	created() {
		if(!('bounceToHome' in this.$route.params) || this.$route.params.bounceToHome === 'true') {
			this.$router.push({name: ERouteName.Home});
		}
	}
}
